import React from "react";
import "./AboutMe.css";
// Import local images
import AboutNav from "../assets/AboutNav.jpg";
import AboutMeImage from "../assets/AboutMe.jpg";

const AboutMe = () => {
  // Remove the useEffect and state management for Firebase
  // Directly use imported images

  return (
    <div className="about-me">
      {/* Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `url(${AboutNav})`,
        }}
      >
        <div className="hero-content">
          <h1>About Me</h1>
          <p className="hero-subtitle">Capturing Life's Beautiful Moments</p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-container">
        <div className="about-content">
          {/* Profile Section */}
          <div className="profile-section">
            <div className="profile-image">
              <img src={AboutMeImage} alt="Profile" className="profile-photo" />
            </div>

            <div className="profile-info">
              <h2>Hello, I'm Dilan Munasingha</h2>

              <p className="intro-text">
                A Fashion & Commercial Photographer with over 7 years of
                experience in creating impactful visual content. Holding a
                Diploma in Image Arts from the University of Kelaniya (UOK), I
                specialize in fashion editorials, commercial campaigns, brand
                storytelling, and creative photography.
              </p>
              <p className="intro-text">
                Throughout my career, I have worked with models, brands, and
                businesses to produce professional imagery that captures
                attention and delivers results. My approach combines creativity,
                technical expertise, and a strong understanding of visual
                communication to ensure every project stands out.
              </p>
              <p className="intro-text">
                Whether it's a fashion campaign, commercial advertisement, or
                creative concept, I am committed to delivering high-quality
                photography that brings ideas to life.
              </p>

              <div className="stats-grid">
                <div className="stat-item">
                  <h3>500+</h3>
                  <p>Projects Completed</p>
                </div>
                <div className="stat-item">
                  <h3>5+</h3>
                  <p>Years Experience</p>
                </div>
                <div className="stat-item">
                  <h3>1000+</h3>
                  <p>Happy Clients</p>
                </div>
              </div>
            </div>
          </div>

          {/* My Story Section */}
          <section className="story-section">
            <h2>My Story</h2>
            <div className="story-content">
              <p>
                My journey began with a camera, a creative vision, and a determination to turn passion into a profession. What started as a 
                deep interest in visual storytelling has evolved into more than 7 years of experience in fashion and commercial photography.
              </p>
              <p>
                Along the way, I earned my Diploma in Image Arts from the University of Kelaniya (UOK) and had the opportunity to work with
                 models, brands, businesses, and creative professionals on a wide range of projects. Each experience has shaped my artistic 
                 perspective and strengthened my commitment to creating impactful imagery.
              </p>
              <p>Today, my mission is simple: to create photographs that do more than capture a moment they tell a story, build a brand,
                 and leave a lasting impression.</p>
            </div>
          </section>

          {/* Specialties Section */}
          <section className="specialties-section">
            <h2>My Specialties</h2>
            <div className="specialties-grid">
              <div className="specialty-card">
                <div className="specialty-icon">📷</div>
                <h3>Portrait Photography</h3>
                <p>
                  Capturing the unique personality and essence of individuals
                </p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">🕶️</div>
                <h3>Fashion Photography</h3>
                <p>Showcasing modern fashion with creativity and confidence</p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">❤️</div>
                <h3>Wedding Photography</h3>
                <p>Documenting love stories and special moments</p>
              </div>
              <div className="specialty-card">
                <div className="specialty-icon">🏷️</div>
                <h3>Commercial Photography</h3>
                <p>Professional images for businesses and brands</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
